// helper function to access the resource with the token
export const HEADERS = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}
